import { render } from "./GridTabContacte.vue?vue&type=template&id=1a379758&scoped=true&ts=true"
import script from "./GridTabContacte.vue?vue&type=script&lang=ts"
export * from "./GridTabContacte.vue?vue&type=script&lang=ts"

import "./GridTabContacte.vue?vue&type=style&index=0&id=1a379758&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a379758"]])

export default __exports__